<div class="preview-content">
  <div >
    <app-desktop></app-desktop>
  </div>
  <div>
    <app-mobile></app-mobile>
  </div>
</div>